<template>

    <form ref="escolabox-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-4">
                <label for="planoServicoId">Plano Servico</label>
                <select v-select="{ dataitem: 'PlanoServico', default: 'Todos' }" v-model="model.planoServicoId" class="form-control" name="planoServicoId"></select>
            </div>

            <div class="form-group col-md-4">
                <label for="porteEscolaId">Porte da Escola</label>
                <select v-select="{ dataitem: 'PorteEscola', default: 'Todos' }" v-model="model.porteEscolaId" class="form-control" name="porteEscolaId"></select>
            </div>

            <div class="form-group col-md-4">
                <label for="tipoImplantacaoId">Tipo Implantacão</label>
                <input type="text" class="form-control" name="tipoImplantacaoId" placeholder="Tipo Implantacão" v-model="model.tipoImplantacaoId" />
            </div>

            <!--<div class="form-group col-md-4">
        <label for="colaboradorResponsavelId">Colaborador Responsável</label>
        <input type="text" class="form-control" name="colaboradorResponsavelId" placeholder="ColaboradorResponsavelId" v-model="model.colaboradorResponsavelId" required />
    </div>-->

            <div class="form-group col-md-4">
                <label for="emailEnvio">Email para Envio</label>
                <input type="text" class="form-control" name="emailEnvio" placeholder="Email de Envio" v-model="model.emailEnvio" />
            </div>

            <div class="form-group col-md-4">
                <label for="passwordEnvio">Password Envio</label>
                <input type="text" class="form-control" name="passwordEnvio" placeholder="Password de Envio" v-model="model.passwordEnvio" />
            </div>

            <div class="form-group col-md-4">
                <label for="statusUsoBox">Status Uso Box</label>
                <input type="text" class="form-control" name="statusUsoBox" placeholder="Status Uso Box" v-model="model.statusUsoBox" required />
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="habilitarMonitoramento" class="custom-control-input" v-model="model.habilitarMonitoramento">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Habilitar Monitoramento?</span>
                </label>
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="temModuloConsultivo" class="custom-control-input" v-model="model.temModuloConsultivo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Tem Módulo Consultivo?</span>
                </label>
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativa?</span>
                </label>
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="cobrar" class="custom-control-input" v-model="model.cobrar">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Cobrar?</span>
                </label>
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="sinalizarInadimplencia" class="custom-control-input" v-model="model.sinalizarInadimplencia">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">Inadimplência Sinalizada?</span>
                </label>
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="inadimplente" class="custom-control-input" v-model="model.inadimplente">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">Está Inadimplente?</span>
                </label>
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="mostrarAviso" class="custom-control-input" v-model="model.mostrarAviso">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Mostrar Aviso?</span>
                </label>
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="bloquearSistema" class="custom-control-input" v-model="model.bloquearSistema">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Box Bloqueado?</span>
                </label>
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="temCnaTalk" class="custom-control-input" v-model="model.temCnaTalk">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">CNA Talk?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <label for="statusUsoBox">Data Virada do Box</label>
                <input type="text" class="form-control"  v-datepicker name="dataViradaParaBox"  v-model="model.dataViradaParaBox"  />
            </div>
            <div class="form-group col-md-8">
                <label for="statusUsoBox">Status Implantação</label>
                <textarea type="text" maxlength="500"  class="form-control" name="statusImplantacao"  v-model="model.statusImplantacao" >
                </textarea>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "escolabox-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "escolabox-form-edit",

            resources: {
                edit: 'escolabox',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ escolaId: this.id }).then(data => {

                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>